/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const updateMonitoringIntegrationBodyTeamIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateMonitoringIntegrationBodyDefaultCustomerIdOneRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const updateMonitoringIntegrationBodyPriorityPolicyOnePriorityMax = 4;

export const updateMonitoringIntegrationBodyPriorityPolicyTwoDefaultPriorityMax = 4;

export const updateMonitoringIntegrationBodyExpectedVersionExclusiveMin = 0;
export const updateMonitoringIntegrationBodyExpectedVersionMax = 9007199254740991;

export const UpdateMonitoringIntegrationBody = zod.object({
  name: zod.string(),
  teamId: zod.union([zod.uuid().regex(updateMonitoringIntegrationBodyTeamIdOneRegExp), zod.null()]),
  defaultCustomerId: zod.union([
    zod.uuid().regex(updateMonitoringIntegrationBodyDefaultCustomerIdOneRegExp),
    zod.null(),
  ]),
  priorityPolicy: zod.union([
    zod.object({
      mode: zod.literal('fixed'),
      priority: zod.int().min(1).max(updateMonitoringIntegrationBodyPriorityPolicyOnePriorityMax),
    }),
    zod.object({
      mode: zod.literal('payload'),
      field: zod.string().nullable(),
      defaultPriority: zod
        .int()
        .min(1)
        .max(updateMonitoringIntegrationBodyPriorityPolicyTwoDefaultPriorityMax),
    }),
  ]),
  expectedVersion: zod
    .int()
    .gt(updateMonitoringIntegrationBodyExpectedVersionExclusiveMin)
    .max(updateMonitoringIntegrationBodyExpectedVersionMax),
});

export type UpdateMonitoringIntegrationBody = zod.input<typeof UpdateMonitoringIntegrationBody>;
export type UpdateMonitoringIntegrationBodyOutput = zod.output<
  typeof UpdateMonitoringIntegrationBody
>;
